"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGatewayHost = function (gateway) {
    return (window.location.origin || 'https://secure.skype.com').replace(/secure\.skype/, gateway + '\.skype');
};
//# sourceMappingURL=getGatewayHost.js.map